import CustomerDetailsControllerClass from "./CustomerDetailsController";

let CCustomerDetails = null;

export function CustomerDetailsController() {
  if (!CCustomerDetails) {
    CCustomerDetails = new CustomerDetailsControllerClass();
  }

  return CCustomerDetails;
}

